import styled from 'styled-components'

import { helpers } from 'styles'

export const Menu = styled.div`
	background-color: ${helpers.color.background};
	border: 1px solid ${helpers.color.border};
	border-radius: 8px;
	box-shadow: 0 8px 24px ${helpers.color.cardShadow};
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 192px;
	padding: 4px;
	z-index: 1000;
`
